import { auth, accountAPI } from "services";
import Parse from "./parse.service";
const Reminder = Parse.Object.extend("Reminder");

//const userACL = auth.userACL();

export const addReminder = async (accountId, date, isEnabled) => {
  const reminder = new Reminder();
  reminder.setACL(new Parse.ACL(Parse.User.current()));
  
  const account = await accountAPI.getAccountById(accountId);
  reminder.set("accountId", account);
  reminder.set("date", date);
  reminder.set("enabled", isEnabled);

  return await reminder.save();
};

//toggle the enabled column based on reminder Id
export const toggleReminder = async (reminderId) => {
  const query = new Parse.Query(Reminder);
  // query.equalTo("objectId", id);
  // const reminder = await query.get(id);
  const reminder = await query.get(reminderId)
  reminder.set("enabled", !reminder?.get("enabled"));
  return await reminder.save();
};

export const getReminderAlert = async (id) => {
  const currentdate = new Date().toLocaleString("en-US", {
    hours12: true,
    day: "2-digit",
  });
  //const reminder = await api.getReminderById(id);
  const myAccount = await accountAPI.getAccountById(id);
  const serverDate = myAccount.get("date");
  if (serverDate == currentdate) {
    return { status: "success" };
  } else {
    return { status: "error" };
  }
};

//fetch the reminder data of current user
export const fetchReminder = async (accountId) => {
  try {
    const currentUser = auth.fetchUser();

    //creating account pointer
    const Account = Parse.Object.extend("Account");
    const accountPointer = new Account();
    accountPointer.id = accountId;

    const query = new Parse.Query(Reminder);
    query.equalTo("accountId", accountPointer); //account pointer

    const reminder = await query.find();
    return reminder;
  } catch (error) {
    console.error("fetchreminder Error: ", error);
  }
};

export const fetchAllReminder = async(accountId)=>{
  try {
    const query = new Parse.Query(Reminder);
    query.include("accountId",accountId);
    const response = await query.find();
    return response;
    
  } catch (error) {
    console.error("fetchAllReminder error: ",error)
  }
}
export const deleteReminder = async (reminderId) => {
  try {
    const query = new Parse.Query(Reminder);
    query.equalTo("objectId", reminderId);
    const reminder = await query.get(reminderId);
    const response = await reminder.destroy();
    return response
  } catch (error) {
    console.error("deletereminder error: ", response);
  }
};

export const getOverdueAccounts = async () => {
  try {
    const query = new Parse.Query(Reminder);
    query.lessThan("date", new Date());
    query.include("accountId");
    const response = await query.find();
    return response;
  } catch (error) {
    console.error("getOverdueAccounts error: ", error);
  }
};
